import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import { addShowValidation } from "../../../utils/validations";

const EditShow = (props) => {
  const { getShow, setEditOpen, setNotify, notify, editOpen, showDetail, setLoder, loder, editShow, userId } = props;
  const [initialValues, setInitialValues] = useState({
    showName: "",
    showCast: "",
  });
  const closeModal = () => {
    setEditOpen(false);
  };

  const handleSubmit = async (values) => {
    setLoder(true);
    const { value } = await editShow({
      userId,
      showId: showDetail?.showId,
      showName: values?.showName,
      showCast: values?.showCast !== "" ? values?.showCast.toString().split(",") : [],
    });
    if (value.status) {
      if (value?.message === "Show already exists...") {
        setNotify(true);
      } else {
        notification["success"]({ message: value.message });
        setNotify(false);
        setEditOpen(false);
      }
    } else {
      notification["error"]({ message: value.message });
    }
    getShow();
    setLoder(false);
  };

  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };

  useEffect(() => {
    if (showDetail) {
      setInitialValues({
        showName: showDetail?.showName,
        showCast: showDetail?.showCast.length > 0 ? showDetail?.showCast.toString().split(",") : "",
      });
    }
  }, [showDetail]);

  return (
    <>
      <Modal
        isOpen={editOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered filter-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Show</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialValues} validationSchema={addShowValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        {" "}
                        Show Name <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="form-control"
                          name="showName"
                          type="text"
                          placeholder="Enter show Name"
                          value={values.showName}
                          onChange={(e) => handlChange(setFieldValue, e)}
                        />
                        {notify && <div className="invalid-feedback">show already exists!</div>}
                        {touched.showName && errors.showName && (
                          <div className="invalid-feedback">{errors.showName}</div>
                        )}
                      </div>
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">Show cast</label>
                      <Field className="form-control" name="showCast" type="text" placeholder="Enter cast" />
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Edit
                        {loder && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditShow;
